import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Subject, takeUntil } from 'rxjs';
import { NotificationService } from '../../../services/notification.service';
import { AuthService } from '../../../services/auth.service';
import { PresenceUser } from '../../../features/games/models/game.models';
import { resolveUserAvatarUrl } from '../../avatar/avatar-presets';
import { getUserLevel, UserLevel } from '../../level.utils';

/**
 * Icono verde junto a la campana: muestra cuántos compañeros están en línea y,
 * al tocarlo, quiénes son. Usa la presencia del socket global de NotificationService.
 */
@Component({
  selector: 'app-online-users',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './online-users.component.html',
  styleUrls: ['./online-users.component.css'],
})
export class OnlineUsersComponent implements OnInit, OnDestroy {
  private readonly notifications = inject(NotificationService);
  private readonly auth = inject(AuthService);
  private readonly destroy$ = new Subject<void>();

  readonly faUser = faUser;
  open = false;
  /** Compañeros en línea, sin incluirme a mí. */
  others: PresenceUser[] = [];
  private myUid: string | null = null;
  private all: PresenceUser[] = [];

  ngOnInit(): void {
    this.auth.currentUser$.pipe(takeUntil(this.destroy$)).subscribe((u) => {
      this.myUid = u?.uid ?? null;
      this.recompute();
    });
    this.notifications.onlineUsers$.pipe(takeUntil(this.destroy$)).subscribe((users) => {
      this.all = users;
      this.recompute();
    });
    document.addEventListener('click', this.onDocumentClick);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    document.removeEventListener('click', this.onDocumentClick);
  }

  private onDocumentClick = (): void => {
    this.open = false;
  };

  private recompute(): void {
    this.others = this.all.filter((u) => u.userId !== this.myUid);
  }

  toggle(event: Event): void {
    event.stopPropagation();
    this.open = !this.open;
  }

  avatarUrl(user: PresenceUser): string {
    return resolveUserAvatarUrl(user?.avatarPreset, user?.photoUrl || user?.photoObjectName);
  }

  getUserLevel(user: PresenceUser): UserLevel | null {
    if (user?.points === undefined || user?.points === null) return null;
    return getUserLevel(user.points);
  }
}
